import { Typography, Button, Row, Col } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./missing-doc-modal.scss";
import MissingDocGif from "../../../../assets/images/missing-doc.gif";

const { Title } = Typography;

const MissingDocModal = ({
  onClose,
  handleMissingDocSubmit,
  isFileUploaded,
}) => {
  const title = isFileUploaded
    ? "Moving Ahead Without Documents"
    : "Document Missing!";
  const message = isFileUploaded
    ? "We noticed some uploaded documents may be missing or incomplete. Please review and confirm."
    : "Thanks for sharing your details! We’re submitting what you’ve provided so far.";

  return (
    <div className="missing-doc-modal-body">
      <Row justify="space-between" align="middle" className="modal-title">
        <Col>
          <Title
            level={5}
            style={{
              fontWeight: 500,
              fontSize: "18px",
              lineHeight: "150%",
              letterSpacing: 0,
              margin: 0,
            }}
          >
            {/* Document Missing! */}
            {title}
          </Title>
        </Col>
        <Col>
          <Button
            icon={<CloseOutlined />}
            type="text"
            onClick={onClose}
            style={{
              width: "24px",
              height: "24px",
              fontSize: "16px",
              color: "var(--text, #000)", // optional: make sure it's visible
            }}
          />
        </Col>
      </Row>
      <div>
        <img
          src={MissingDocGif}
          alt="Computer man"
          style={{ width: "180px", height: "180px" }}
        ></img>
        {/* <p>
          Thanks for sharing your details! We’re submitting what you’ve provided
          so far.
        </p> */}
        <p>{message}</p>
        <Row
          justify="center"
          gutter={8}
          style={{
            width: "100%",
            bottom: 0,
            position: "sticky",
          }}
        >
          <Col span={12}>
            <Button
              style={{ width: "100%", margin: "0px" }}
              size="large"
              className="skip-button"
              //   onClick={() => onSectionChange(SignUpSteps.BASIC_INFO)}
              onClick={onClose}
            >
              Cancel
            </Button>
          </Col>
          <Col span={12}>
            <Button
              style={{ width: "100%", margin: "0px" }}
              size="large"
              className="submit-button"
              onClick={handleMissingDocSubmit}
            >
              {isFileUploaded ? "OK" : "Submit"}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default MissingDocModal;
